<template>
    <div>
        <div class="position-relative " style=" min-height:150px;">
            <el-tooltip :content="item.name" v-for="item in univerSityData" :key="item.id" placement="top-start" >
                <el-button size="mini" type="primary"  class="title text-ellipsis float-left margin-left  margin-top"  @click="selectDt(item)" >
                    {{item.name}}

                </el-button>
            </el-tooltip>
        </div>
        <div  style="height:400px;width:800px;" class="position-relative boxDt m-auto" >
            <div id="allPanoramaPicture"    v-show="univerSityData.length>0"  >
            </div>
            <empty v-show="univerSityData.length<1&&!loadingDt" content="暂无全景地图" :text-size="18" :widths="150" :heights="150">
            </empty>
            <loading :show="loadingDt" width="1025px"></loading>
        </div>
    </div>
</template>

<script>
    import {EventBus} from "../../../../../assets/static/global/event-bus";
    import {uniRankMap} from "../../../../../config";

    export default {
        name: "allPanoramaPicture",
        props:{
            univerSityId:String
        },
        data(){
            return{
                //获取当前已选择的经纬度
                selectData:'',
                univerSityData:[],
                wd:'',
                jd:'',
                loadingDt:false
            }
        },
        mounted() {
            //查询全景校园
            EventBus.$on('qjSchool',(()=>{
                this.searchQjtJwD();
            }));
        },
        methods:{
            //查出全景图
            async searchQjtJwD(){
                this.loadingDt=true;
                let result=await uniRankMap(this.univerSityId);
                if(result.status){
                    this.loadingDt=false;
                    this.univerSityData=result.data;
                    this.selectData=result.data[0];
                    if(result.data.length>0){
                        this.yxPicture();
                    }else{

                    }
                }else{
                    this.loadingDt=false;
                }
            },
            selectDt(val){
                document.getElementById('allPanoramaPicture').remove();
                let zhi=document.createElement('div');
                zhi.setAttribute('id','allPanoramaPicture');
                zhi.setAttribute('class','margin-top');
                document.querySelector('.boxDt').appendChild(zhi);
                this.selectData=val;

                  this.yxPicture();

            },
              yxPicture(){
                var panorama = new BMap.Panorama('allPanoramaPicture'); //默认为显示导航控件
                panorama.setPosition(new BMap.Point(this.selectData.lnt,this.selectData.lat));
                panorama.addEventListener('position_changed', function(e){ //全景位置改变事件
                    panoramaCallBack(e);
                });
                panorama.addEventListener('pov_changed', function(e){ //全景视角改变事件
                    panoramaCallBack(e);
                });
                function panoramaCallBack(e){ //事件回调函数
                    if (e.type == 'onpov_changed') {
                        document.getElementById('svInfoText').innerHTML="全景视角为：<br/>"+"水平视角："+panorama.getPov().heading+"<br/>垂直视角："+panorama.getPov().pitch;
                    }
                    else if (e.type=='onposition_changed') {
                        document.getElementById('svInfoText').innerHTML="全景位置点为："+panorama.getPosition().lng+","+panorama.getPosition().lat;
                    }
                }
            }
        }

    }
</script>
<style>
    #allPanoramaPicture{
        height:400px;width:800px;
    }
</style>
<style scoped>
    .title{
        width:100px;
    }

</style>